import { createContext } from "react";

const ExpedienteMedicoContext = createContext();

export default ExpedienteMedicoContext;
